<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <Sidebar></Sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <h2>Find Sites</h2>
          </a-col>
        </a-row>
        <search-site/>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import SearchSite from "@/components/Sites/SearchSite.vue";

export default {
  name: 'FindSite',
  components: {
    SearchSite,
    Sidebar,
  },
}
</script>